// [qrprint] Modal for QR Code table printing
// mode: 'grid' | 'receipt' | 'dynamic'
//   grid    — batch A4 grid (multiple tables, static QR)
//   receipt — single table thermal receipt (static QR)
//   dynamic — dynamic session QR, reads state.bill.data like ReceiptPrintPage
import { createPortal } from "react-dom";
import React, { useEffect } from "react";
import QrTablePrintPage from "pages/QrTablePrintPage";
import { getAutoPrint } from '../../../utils/printerSettings';
import { electronPrint, isElectron } from '../../../services/electronPrint.service';

export default function ModalQrTablePrint({
  isOpen,
  // grid mode
  tables,
  zoneId,
  zoneName,
  slug,
  // receipt mode (single table static)
  table,
  shopName,
  // dynamic mode
  mode,
  qrToken,
  qrUrl,
  expiresAt,
  tableName,
  onPrintComplete,
}) {
  const printMode = mode || (tables && tables.length > 0 ? "grid" : "receipt")

  useEffect(() => {
    if (!isOpen) return

    const printTimer = setTimeout(async () => {
      // grid mode in Electron — print each table QR individually
      if (isElectron() && printMode !== 'grid') {
        await electronPrint('qrTable', { table, shopName, qrUrl, qrToken, tableName, expiresAt })
        if (onPrintComplete) setTimeout(() => onPrintComplete(), 200)
        return
      }
      if (getAutoPrint()) {
        window.print()
        if (onPrintComplete) setTimeout(() => onPrintComplete(), 500)
      }
    }, 500)
    return () => clearTimeout(printTimer)
  }, [isOpen, onPrintComplete, printMode, table, shopName, qrUrl, qrToken, tableName, expiresAt])

  if (!isOpen) return null

  const sectionClass = printMode === "grid"
    ? "section-to-print-qr-page"
    : "section-to-print-qr-receipt-page"

  return (
    <>
      {createPortal(
        <div className={sectionClass}>
          <QrTablePrintPage
            mode={printMode}
            tables={tables}
            zoneId={zoneId}
            zoneName={zoneName}
            slug={slug}
            table={table}
            shopName={shopName}
            qrToken={qrToken}
            qrUrl={qrUrl}
            expiresAt={expiresAt}
            tableName={tableName}
          />
        </div>,
        document.body
      )}
    </>
  )
}
// =====================[ModalQrTablePrint]=====================
